import { render, staticRenderFns } from "./InfographicHighlight.vue?vue&type=template&id=4c52318f&scoped=true&"
import script from "./InfographicHighlight.vue?vue&type=script&lang=js&"
export * from "./InfographicHighlight.vue?vue&type=script&lang=js&"
import style0 from "./InfographicHighlight.vue?vue&type=style&index=0&id=4c52318f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c52318f",
  null
  
)

export default component.exports